<template>
  <ConfirmationModal
    :title="$t('DELETE_CALL_FLOW_CONFIRMATION_TITLE')"
    :entity="callFlowTree"
    :show-confirm-button="true"
    :show-cancel-button="true"
    :cancel-button-text="$t('CANCEL')"
    :confirm-action-text="$t('DELETE')"
    :confirm-button-disabled="disableModalConfirm"
    :confirm-button-loading="deletingCallFlowTree"
    @close="closeModal"
    @confirm="deleteCallFlow"
  >
    <div v-if="loadingCallFlowTreeReferences">
      <Loader custom-class="size-sm" />
      <span v-html="$t('DELETE_CALL_FLOW_MODAL_CHECK_ASSOCIATION_TEXT', { callFlowTreeToDeleteName })"></span>
    </div>
    <div v-else>
      <p 
        v-if="!hasReferences"
        v-html="$t('DELETE_CALL_FLOW_MODAL_NONE_ASSOCIATION_TEXT', { callFlowTreeToDeleteName })">
      </p>
      <div v-else>
        <p v-html="$t('DELETE_CALL_FLOW_MODAL_ASSOCIATION_TEXT', { callFlowTreeToDeleteName })" class="m-b-10"></p>
        <div class="well well-sm m-b-10">
          <div class="form-horizontal">

            <div class="row">
              <label class="col-md-3 control-label">
                <strong>Campaigns</strong>
              </label>
              
              <div class="col-md-8">
                <ul class="list-unstyled form-control-static list-text-overflow">
                  <li v-for="(campaign, index) in callFlowTreeReferences.campaigns">
                    <a :href="`#/dashboard/campaign/${campaign.campaignId}`" target="_blank">
                      <span class="display-text" :title="campaign.campaignName">
                        {{ campaign.campaignName }}
                        <i
                          class="fa fa-exclamation-circle text-danger f-s-14 m-l-5" v-if="campaign.campaignNoRoutes"
                          v-tooltip.right.hover="$t('NO_ROUTE_SETUP_WARNING')"
                          aria-hidden="true"
                        />
                      </span>
                      <i v-tooltip.right.hover="$t('VIEW_CAMPAIGN_TEXT')"
                        tooltip-placement="right" 
                        class="fa fa-external-link m-l-5"
                        aria-hidden="true"
                        />
                    </a>
                  </li>
                </ul>

              </div>
            </div>

          </div>
        </div>
        <div class="form-horizontal m-l-10 m-r-10">
            <div class="checkbox f-s-14">
              <label>
                <input
                  type="checkbox"
                  v-model="forceDelete"
                  @change="attestDelete"
                />
                <span v-t="'DELETE_CALL_FLOW_ATTEST'"></span>
              </label>
            </div>
        </div>
      </div>
    </div>

  </ConfirmationModal>
</template>

<script>
import Loader from '@/core/components/Loader';
import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal';
import messages from '../../locales';
import sharedMessages from '@/core/locales';

export default {
  name: 'CallFlowDeleteModal',
  components: {
    Loader,
    ConfirmationModal
  },
  props:{
    callFlowTree: {
      type: Object,
      default() {
        return {};
      }
    },
    callFlowTreeReferences: {
      type: Object,
      default() {
        return {};
      }
    },
    disableModalConfirm: {
      type: Boolean,
      default: false
    },
    deletingCallFlowTree: {
      type: Boolean,
      default: false
    },
    loadingCallFlowTreeReferences: {
      type: Boolean,
      default: false
    },
    hasReferences: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      forceDelete: false,
    };
  },
  computed: {
    callFlowTreeToDeleteName() {
      return this.callFlowTree?.name;
    }
  },
  methods:{
    closeModal() {
      this.$emit('closeModal');
    },
    deleteCallFlow() {
      this.$emit('deleteCallFlow', this.callFlowTree);
    },
    attestDelete() {
      this.$emit('attestDelete', this.forceDelete);
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>